import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Input, Radio } from "antd";
import "antd/dist/antd.css";
import "./Main.css";
import TopNav from "./TopNav";
import MainNav from "./MainNav";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import PopupComponent from "../util/SmartKeyPopup";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import Pagination from "react-js-pagination";
import pagiarray from "paginate-array";
import Filter from "../util/Filter";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { BulbFilled } from "@ant-design/icons";
import CenterSelect from "../lib/CenterSelect";
import pr from "../util/pr";
import GetHost from "../lib/GetHost";
import ClearEmpty from "../lib/ClearEmpty";
import PhoneFomatter from "../lib/PhoneFormatter";
import PtCouponEdit from "./PtCouponEdit";
import PtCouponAdd from "./PtCouponAdd";
import PtMemberAdd from "./PtMemberAdd";
import moment from "moment";

let result;
var activePage = 1;
var totalCount = 0; //총회원수
const pageSize = 10;
var visitData = "";
var clear = false;
var name = "";
var phone = "";

var filterMode = {
  name: true,
  phone: true,
};

let storage = {
  nameKeyword: "",
  phoneKeyword: "",
  popupMode: "",
  popupData: {},
};

const TableStyle = styled(Table)`
  tbody tr:hover {
    cursor: pointer;
  }
`;

const columns = [
  {
    dataIndex: "regdate",
    key: "regdate",
    title: "등록일",
    align: "center",
    width: 160,
    render: (text) => {
      const x = moment(text).format('YYYY-MM-DD HH:mm');
      return <div>{x}</div>;
    },
  },
  {
    dataIndex: "center_name",
    key: "center_name",
    title: "센터명",
    align: "center",
    width: 200,
  },
  {
    dataIndex: "mb_name",
    key: "mb_name",
    title: "이름",
    align: "center",
    width: 100,
  },
  {
    dataIndex: "mb_phone",
    key: "mb_phone",
    title: "연락처",
    align: "center",
    width: 160,
    render: (text) => {
      return PhoneFomatter(text);
    },
  },
  {
    dataIndex: "pt_type",
    key: "pt_type",
    title: "쿠폰종류",
    align: "center",
    width: 100,
  },
  {
    dataIndex: "valid_date",
    key: "valid_date",
    title: "유효기간",
    align: "center",
  },
  {
    dataIndex: "coupon_count",
    key: "coupon_count",
    title: "수량",
    align: "center",
    width: 100,
  },
  {
    dataIndex: "state",
    key: "state",
    title: "상태",
    align: "center",
    width: 100,
    render: (text) => {
      if (text === "Y") {
        return <BulbFilled style={{ fontSize: 16, color: "green" }} />;
      } else {
        return <BulbFilled style={{ fontSize: 16, color: "#CCCCCC" }} />;
      }
    },
  },
];

const state = false;

const token = localStorage.getItem("refresh_token"); // 토큰

let formData = {
  name: "",
  phone: "",
};

function PtCoupon() {
  const [member, setMember] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState("");
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [cid, setCid] = useState();
  const [addVisible, setAddVisible] = useState(false); // 등록팝업
  const [editVisible, setEditVisible] = useState(false); // 수정팝업
  const [memberVisible, setMemberVisible] = useState(false); // 회원찾기 팝업
  const [seq, setSeq] = useState(0);
  const [total, setTotal] = useState("");
  const [form] = Form.useForm();

  // ADD > SEARCH
  const [addSearch, setAddSearch] = useState({ mb_name: "", mcd: "" });

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        // console.log(record, rowIndex, event);
        setSeq(record.seq);
        onShowEditModal();
      },
    };
  };

  function getMember() {}

  async function main() {
    const result = await LoginCheck(data.url);
    if (result === "Y") {
      const decodeResult = await DecodeData(data.url);
      dispatch({ type: "SET", name: "CID", value: decodeResult.cid });
      dispatch({ type: "SET", name: "LEVEL", value: decodeResult.level });

      // 시작시 데이타 로드
      get_list_count({});
      get_list_data({});
    } else {
      LoginFail();
    }
  }

  useEffect(() => {
    main();
  }, []);

  useEffect(() => {
    if (data.cid === "root") {
      getMember();
      activePage = 1;
    }
  }, [selectedCenter]);

  // 리스트 데이타
  const get_list_data = async (params) => {
    let { sname, sphone } = params;
    sname = ClearEmpty(sname);
    sphone = ClearEmpty(sphone);

    if (data.cid !== "") {
      if (data.cid === "root") {
        // 최고관리자
        result = await axios.post(GetHost() + "/gympass_admin/pt_coupon", {
          token: token,
          cid: cid,
          sname: sname,
          sphone: sphone,
        });
        setRows(result.data);
      } else {
        // 지점관리자
        result = await axios.post(GetHost() + "/gympass_admin/pt_coupon", {
          token: token,
          cid: data.cid,
          sname: sname,
          sphone: sphone,
        });
        setRows(result.data);
      }
    }
  };

  // 리스트 데이타 (카운트)
  const get_list_count = async (params) => {
    let { sname, sphone } = params;
    sname = ClearEmpty(sname);
    sphone = ClearEmpty(sphone);

    if (data.cid !== "") {
      if (data.cid === "root") {
        // 최고관리자
        result = await axios.post(
          GetHost() + "/gympass_admin/pt_coupon_count",
          {
            token: token,
            cid: cid,
            sname: sname,
            sphone: sphone,
          }
        );
        setTotal(result.data.count);
      } // 지점관리자
      else {
        result = await axios.post(
          GetHost() + "/gympass_admin/pt_coupon_count",
          {
            token: token,
            cid: data.cid,
            sname: sname,
            sphone: sphone,
          }
        );
        setTotal(result.data.count);
      }
    }
  };

  const onCenterChange = (value) => {
    setCid(value);
  };

  const onReload = () => {
    window.location.reload();
  };

  // 검색
  const onFinish = () => {};

  const onNameChange = event => {
    formData.name = event.target.value;
  }

  const onPhoneChange = event => {
    formData.phone = event.target.value;
  }

  const onSubmit = () => {
    pr('onSubmit');
    get_list_count({ sname: formData.name, sphone: formData.phone });
    get_list_data({ sname: formData.name, sphone: formData.phone });
  };

  // 모달 보기/감추기
  const onShowEditModal = () => {
    setEditVisible(true);
  };

  const onHideEditModal = () => {
    setEditVisible(false);
  };

  const onShowAddModal = () => {
    setAddVisible(true);
  };

  const onHideAddModal = () => {
    setAddVisible(false);
  };

  const onShowMemberModal = () => {
    setMemberVisible(true);
  };

  const onHideMemberModal = () => {
    setMemberVisible(false);
  };

  // 쿠폰추가/회원찾기 > 팝업에서 클릭 후 처리
  // 유즈 스테이트를 이용해서 : 자식 > 부모 > 자식 호출
  const onFindMember = (params) => {
    let { mb_name, mcd } = params;
    setAddSearch({
      mb_name: mb_name,
      mcd: mcd,
    });
  };

  return (
    <main className="main-container">
      <TopNav />
      <div className="content-wrapper">
        <MainNav />
        <div className="content-inner smartkey">
          <PtCouponAdd
            visible={addVisible}
            onHideModal={() => onHideAddModal()}
            onShowMemberModal={() => onShowMemberModal()}
            addSearch={addSearch}
            onReload={onReload}
          />

          <PtCouponEdit
            seq={seq}
            visible={editVisible}
            onHideModal={() => onHideEditModal()}
            onReload={() => onReload()}
          />

          <PtMemberAdd
            seq={seq}
            visible={memberVisible}
            onHideModal={() => onHideMemberModal()}
            onReload={() => onReload()}
            onFindMember={(params) => onFindMember(params)}
          />

          <h3>PT/GX 쿠폰</h3>
          <div className="content-component">
            <div className="content-header">
              <Button className="add-button" onClick={() => onShowAddModal()}>
                쿠폰 추가
              </Button>
            </div>
            <div>Total:{total}</div>

            <div style={{ float: "right" }}>
              <Form form={form} onFinish={onFinish}>
                <Input.Group compact>
                  <Form.Item name="sname">
                    <Input autoComplete="off" placeholder="이름" onChange={onNameChange}></Input>
                  </Form.Item>
                  <Form.Item name="sphone">
                    <Input autoComplete="off" placeholder="연락처" onChange={onPhoneChange}></Input>
                  </Form.Item>
                  <Form.Item style={{ marginLeft: 5 }}>
                    <Button type="primary" onClick={onSubmit}>
                      검색
                    </Button>
                    <Button style={{ marginLeft: 5 }} onClick={onReload}>
                      전체
                    </Button>
                  </Form.Item>
                </Input.Group>
              </Form>
            </div>

            <div className="content-body">
              {data.level === 500 && (
                <div style={{ float: "right", marginBottom: 5 }}>
                  <CenterSelect width="200" onCenterChange={onCenterChange} />
                </div>
              )}

              <TableStyle
                rowKey="seq"
                columns={columns}
                dataSource={rows}
                bordered
                pagination={{
                  pageSizeOptions: [],
                }}
                onRow={onRow}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PtCoupon;
